export default "__VITE_ASSET__94hz6_UK__"